import { ProgressBar } from '@/components/ProgressBar';
import { expressFormulaIntercept, expressFormulaSlope, expressWorkerActivationTime } from '@/environment';
import { IAvatarTrain, isExpressPresenter, Presenter, VideoType } from '@d-id/types';

const AVATAR_TRAIN_DURATION = 20 * 60 * 60;
const STEP_DURATIONS = {
    preprocess: 3.5 * 60,
    'a2e train': 1 * 60,
    'e2p train': 12 * 60,
    trt: 0,
};

interface Props {
    avatar: Presenter;
}

/**
 * Calculate the processing time based on the duration for the express worker.
 * @param duration The duration of the video in seconds.
 * @returns The processing time in seconds rounded to one decimal place. Formula: processingTime = slope * duration + intercept
 * @example processingTime = 13.9303 * duration + 13.8923
 */
export const calculateExpressProcessingTime = (duration: number) =>
    Math.round((expressFormulaSlope * duration + expressFormulaIntercept) * 10) / 10 + expressWorkerActivationTime;

function calculateTrainDuration(avatar: IAvatarTrain) {
    return (duration: number) => {
        /**
         * Prepeoces - 3.5 hours
         * A2e train - 1 hour
         * E2p train - +-12 hours
         * Trt and regiater - a few minutes
         */
        switch (avatar.progress?.step) {
            case 'preprocess':
                return duration;
            case 'a2e train':
                return duration - STEP_DURATIONS['preprocess'];
            case 'e2p train':
                return duration - STEP_DURATIONS['preprocess'] - STEP_DURATIONS['a2e train'];
            case 'trt':
                return duration - STEP_DURATIONS['preprocess'] - STEP_DURATIONS['a2e train'] - STEP_DURATIONS['e2p train'];
            default:
                return duration;
        }
    };
}

export function AvatarProgressBar({ avatar }: Props) {
    if (avatar.type === VideoType.TRAIN) {
        return (
            <ProgressBar
                duration={AVATAR_TRAIN_DURATION}
                startedAt={new Date(avatar.created_at).getTime()}
                calcFormula={calculateTrainDuration(avatar)}
                theme="dark"
                textVariant="text-inside-with-estimation"
            />
        );
    }

    return (
        <ProgressBar
            duration={avatar.source_duration || 60}
            maxProgressShown={isExpressPresenter(avatar) ? 85 : 99}
            startedAt={new Date(avatar.created_at).getTime()}
            calcFormula={calculateExpressProcessingTime}
            theme="dark"
            textVariant="text-inside-with-estimation"
        />
    );
}
